import { defineMessages } from 'react-intl'

const scope = 'procurify.core.features.TakeProductTourButtonPresenter'

export default defineMessages({
  takeTour: {
    id: `${scope}.takeTour`,
    defaultMessage: 'Take a tour',
  },
  popupTitle: {
    id: `${scope}.popupTitle`,
    defaultMessage: 'Product tour',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Something went wrong',
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: "We couldn't open the tour. Please try again.",
  },
})
